export default __webpack_public_path__ + "static/char-v-33-zh-Hant-620f4c9af9c2a53c54dcb535425ad6f4.mp4";